var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "background-color": "rgb(253, 244, 214)",
        position: "relative",
        "border-radius": "4px",
        padding: "20px 20px",
      },
    },
    [
      _vm.title
        ? _c("h2", { staticClass: "search__filter-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "search-outer" }, [
        _c("div", { staticClass: "fias-search-status" }, [
          _vm.loading
            ? _c("i", { staticClass: "lnr lnr-sync rotating" })
            : _c("i", { staticClass: "lnr lnr-magnifier" }),
        ]),
        _vm._v(" "),
        _vm.registry == "fias"
          ? _c(
              "div",
              {
                staticClass: "fias-search-submit",
                on: {
                  click: function () {
                    _vm.searchHandle(_vm.request)
                  },
                },
              },
              [_vm._v("Найти")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.request
          ? _c(
              "div",
              {
                staticClass: "fias-search-erase",
                style: { right: this.registry != "fias" ? "0" : "140px" },
                on: { click: _vm.reset },
              },
              [_c("i", { staticClass: "lnr lnr-cross" })]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "fias-search-input" }, [
          _vm.registry == "fias"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.request,
                    expression: "request",
                  },
                ],
                attrs: { type: "text", placeholder: _vm.inputPlaceholder },
                domProps: { value: _vm.request },
                on: {
                  keypress: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchHandle(_vm.request)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.request = $event.target.value
                  },
                },
              })
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.request,
                    expression: "request",
                  },
                ],
                attrs: { type: "text", placeholder: _vm.inputPlaceholder },
                domProps: { value: _vm.request },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.request = $event.target.value
                    },
                    function ($event) {
                      return _vm.timeoutRequest(_vm.request)
                    },
                  ],
                },
              }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._l(
            _vm.checkedClassificator.filter(function (e, i) {
              return i < 10
            }),
            function (e, i) {
              return _c(
                "code",
                { key: i },
                [
                  _vm.registry == "okved"
                    ? [
                        _vm._v(
                          "\n                " +
                            _vm._s(e.code.replace("2014:", "")) +
                            " - " +
                            _vm._s(e.full_title ? e.full_title : e.title) +
                            "\n            "
                        ),
                      ]
                    : [
                        _vm._v(
                          "\n                " +
                            _vm._s(e.full_title ? e.full_title : e.title) +
                            "\n            "
                        ),
                      ],
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "vertical-align": "middle",
                        cursor: "pointer",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteItemFromChecked(e.id)
                        },
                      },
                    },
                    [_c("i", { staticClass: "lnr lnr-cross" })]
                  ),
                ],
                2
              )
            }
          ),
          _vm._v(" "),
          _vm.checkedClassificator.length > 10
            ? _c("code", [
                _vm._v(
                  "\n            Всего " +
                    _vm._s(_vm.checkedClassificator.length) +
                    " и ещё " +
                    _vm._s(_vm.checkedClassificator.length - 10) +
                    "...\n        "
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-filter" },
        [
          _c("tree", {
            attrs: { registry: _vm.registry, treeArray: _vm.treeArray },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }